import React from "react";
import { Link, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";
import { Box, Stack, Typography } from "@mui/material";

import { LINKS } from "@constants";
import LogoText from "components/common/LogoText";
import eventsService, { EVENTS } from "services/events";

const Footer = () => {
  const { pathname } = useLocation();
  const isOffWhiteBg = LINKS.home === pathname;

  return (
    <Box sx={{ backgroundColor: isOffWhiteBg ? "#F4F4F8" : "#fff" }}>
      <Container disableGutters maxWidth="xl">
        <Stack
          alignItems="center"
          justifyContent="space-between"
          sx={{
            minHeight: 80,
            flexDirection: { xs: "column", md: "row" },
            padding: { xs: "8px 24px", md: "0 60px" },
          }}
        >
          <Stack
            alignItems="center"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: "48px" },
            }}
          >
            <LogoText showMobileLogo dark />
            <Stack spacing={5} direction="row" alignItems="center" height={40}>
              <Typography
                component={Link}
                to={LINKS.termsOfUse}
                sx={{
                  textDecoration: "none",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#747484",
                }}
              >
                Terms Of Use
              </Typography>
              <Typography
                component={Link}
                to={LINKS.requestACall}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textDecoration: "none",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#747484",
                }}
                onClick={() => {
                  eventsService.track(EVENTS.BTB_CTA, {
                    place: "landing_custom_voice",
                  });
                }}
              >
                Contact Us
              </Typography>
            </Stack>
          </Stack>
          <Typography fontSize={14} fontWeight={400} color="#747484">
            © {new Date().getFullYear()} Respeecher. All rights reserved.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
